__turbopack_context__.v({
  "below": "LCatalogTwoColsRight-module__ucoEUW__below",
  "content": "LCatalogTwoColsRight-module__ucoEUW__content",
  "mainColumn": "LCatalogTwoColsRight-module__ucoEUW__mainColumn",
  "root": "LCatalogTwoColsRight-module__ucoEUW__root",
  "sidebar": "LCatalogTwoColsRight-module__ucoEUW__sidebar",
});
